@if (ticketsActionState.pending === false) {
  <div class="tickets">
    <div class="tickets-container">
      <ng-content select="[new-ticket-info]"></ng-content>
      @if (createButtonText && hasActiveContracts) {
        <rs-web-card
          [style]="{ '--card-background-color': 'white' }"
          [hover]="true"
          [borderStyle]="'dashed'"
          (clickEvent)="createTicket.emit()"
        >
          <div class="tickets-create-ticket">
            <rs-web-icon [icon]="immomioIconName.Plus" [size]="12"></rs-web-icon>
            <span class="ms-2">{{ createButtonText | translate }}</span>
          </div>
        </rs-web-card>
      }
      @for (ticket of tickets; track ticket.node.id) {
        <rs-web-ticket-card
          [ticket]="ticket.node"
          (archiveTicket)="archiveTicket.emit($event)"
          (click)="openTicket.emit(ticket.node)"
        ></rs-web-ticket-card>
      }

      @if (hasNextPage) {
        <rs-web-card [hover]="true" [elevation]="2">
          <div class="tickets-card__load-more" (click)="loadMoreTickets.emit()">
            <rs-web-icon [icon]="immomioIconName.Plus" [size]="12"></rs-web-icon>
            <span class="ms-2">{{ 'general.show_more_b' | translate }}</span>
          </div>
        </rs-web-card>
      }
    </div>
    @if (tickets.length === 0) {
      <rs-web-no-data [text]="txtNoTickets" />
    }
    @if (isArchiving) {
      <div class="tickets-archive-overlay">
        <rs-web-loader [centered]="true" [biggerSpinner]="true"></rs-web-loader>
      </div>
    }
  </div>
} @else {
  <rs-web-loading-skeleton
    [show]="true"
    [types]="[LoadingType.TICKETCARD]"
  ></rs-web-loading-skeleton>
}
